import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 关闭 ")

import { reactive } from 'vue';
import { GbDialog } from '@/components/GbDialog/Index';



export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {

const state = reactive({
    show: false,
    title: '文件预览',
    fileUrl:'',
})


const expFuncs = {
    openDialog: (row: any) => {
        state.fileUrl = row.file_url;
        state.title = `文件预览：${row.file_name}`;
        state.show = true;
    }
}

expose({ ...expFuncs })


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createBlock(_unref(GbDialog), {
    modelValue: _unref(state).show,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(state).show) = $event)),
    title: _unref(state).title,
    style: {"width":"1000px"}
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        type: "info",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(state).show = false))
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("iframe", {
        src: _unref(state).fileUrl,
        marginWidth: "0",
        marginHeight: "0",
        scrolling: "no",
        frameBorder: "0",
        style: {"width":"100%","height":"600px"}
      }, "\r\n        ", 8, _hoisted_1)
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})